import React, { useEffect, useState } from "react";
import { Empty, Skeleton, Table, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { getRotoTenderBasicPagination } from "services/redux/officeresource/business/action";
const pageSize = 30;

export default function RotoTender({ filterData }) {
  const { sowDetailsLoading, sowDetails } = useSelector(
    (state) => state.businessCenter
  );

  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [sowDetailsLoad, setSowDetailsLoad] = useState(false);

  useEffect(() => {
    if (!isEmpty(sowDetails?.items)) {
      let newPage = sowDetails?.items?.length / pageSize;
      setCurrentPage(newPage);
    }
  }, [sowDetails]);

  const loadMoreData = async (
    MaxResultCount = pageSize,
    SkipCount = 0,
    loadMore = true
  ) => {
    const params = {
      ...filterData,
      maxResultCount: MaxResultCount,
      skipCount: SkipCount,
    };
    dispatch(getRotoTenderBasicPagination(params, loadMore, setSowDetailsLoad));
  };

  const fetchMoreData = () => {
    loadMoreData(pageSize, currentPage * pageSize, true);
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat().format(number);
  };

  const columns = [
    {
      title: "S No",
      key: "sno",
      render: (text, object, index) => index + 1,
      width: "5%",
    },
    {
      title: "Currency",
      dataIndex: "budgetCurAbbvr",
      key: "budgetCurAbbvr",
    },
    {
      title: "Budget",
      dataIndex: "budget",
      key: "budget",
      render: (text) => {
        return (
          <div
            style={{
              textAlign: "end",
            }}
          >
            {text === 0 ? "-" : formatNumber(text)}
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Reference Code",
      dataIndex: "referenceCode",
      key: "referenceCode",
    },
    {
      title: "SOW",
      dataIndex: "scopeOfWorks",
      key: "scopeOfWorks",
    },
    {
      title: "Category",
      dataIndex: "tenderTypes",
      key: "tenderTypes",
    },
    {
      title: "Sub Category",
      dataIndex: "tenderSubTypes",
      key: "tenderSubTypes",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {/* {record.slice(0, 2).map((item, index) => (
                <span key={index}>{item.name}</span>
              ))}
              {record.length > 2 && <span>...</span>} */}
              {record?.map((item) => item?.tenderTypeName)?.join(", ") ?? ""}
            </div>
          );
        }
      },
    },
    {
      title: "Sector",
      dataIndex: "sectorTypes",
      key: "sectorTypes",
    },
    {
      title: "Sub Sector",
      dataIndex: "sectorSubTypes",
      key: "sectorSubTypes",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {/* {record.slice(0, 2).map((item, index) => (
                <span key={index}>{item.name}</span>
              ))}
              {record.length > 2 && <span>...</span>} */}
              {record?.map((item) => item.sectorName)?.join(", ") ?? ""}
            </div>
          );
        }
      },
    },
  ];

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography.Title level={4}>
          <Typography.Text strong style={{ textAlign: "left" }}>
            Similar Tenders (SOW -{" "}
            {`${filterData !== undefined ? filterData.scopeOfWorks ?? "" : ""}`}
            ) Total Tender - {sowDetails?.totalCount}
          </Typography.Text>
        </Typography.Title>
      </div>
      {sowDetailsLoad ? (
        <Skeleton />
      ) : !isEmpty(sowDetails?.items) ? (
        <>
          <div
            id="rotoTenderDiv"
            style={{
              height: "calc(100vh - 125px)",
              overflow: "auto",
              padding: "0 16px",
              border: "1px solid rgba(140, 140, 140, 0.35)",
            }}
          >
            <InfiniteScroll
              dataLength={sowDetails?.items?.length}
              next={fetchMoreData}
              hasMore={sowDetails?.totalCount > sowDetails?.items?.length}
              loader={<Skeleton active={4} />}
              endMessage={
                <Typography.Title
                  level={4}
                  strong
                  style={{ textAlign: "center" }}
                >
                  End
                </Typography.Title>
              }
              scrollThreshold={0.6}
              scrollableTarget="rotoTenderDiv"
            >
              <Table
                columns={columns}
                dataSource={sowDetails?.items}
                pagination={false}
                // loading={sowDetailsLoading}
                rowKey="id"
                // scroll={{ y: 200 }}
              />
            </InfiniteScroll>
          </div>
        </>
      ) : (
        <Empty />
      )}
    </>
  );
}
